export const NOT_CONFIRMED = 'Order acceptance has not been confirmed.';

export const HAVE_CONFIRMED_SUBTITLE = 'You have confirmed acceptance of this order.';

export const CONFIRMATION_NUM = 'Confirmation number: ';

export const LAST_CHANGE_DATE = 'Last change: ';